import { BaseComponent } from '../../base-component';
import { InstallmentPlanCalculatorSheet } from './installment-plan-calculator-sheet';

const SHEET_OPEN = 'oc-open';

export class InstallmentPlanCalculatorComponent extends BaseComponent {
    public rootSelector = '.js_pdp_installment-plan-calculator';
    public sheetSelector = '#pdp_installment-plan-calculatorSheet';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        const sheet = document.querySelector(this.sheetSelector);
        const installmentPlanCalculatorSheet = new InstallmentPlanCalculatorSheet();
        sheet?.addEventListener(SHEET_OPEN, ev => installmentPlanCalculatorSheet.onSheetOpen(ev));
    }
}
